import { RootState } from "../reducers";

export const getDeviceInfo = (state: RootState) => state.opsMetrics.deviceInfo;

export const getMetricsQueue = (state: RootState) =>
    state.opsMetrics.opsMetricsQueue;
